import { useEffect, useState } from "react";
import { getEntities } from "../dao/common";
import { errorMessageHandler } from "../utils/error";
import { handleDrumNumberPreFill } from "../utils/entityNumberPreFill";
import FieldName from "../enums/FieldName";

const createInitialState = () => ({
  [FieldName.OBJECT_ID]: null,
  number: "",
});

const useDrum = ({ drumId = null, objectId = null, isCreateMode = false }) => {
  const [drum, setDrum] = useState(createInitialState);
  const [isLoading, setIsLoading] = useState(true);

  const fetchDrumData = async (abortController) => {
    if (drumId) {
      // Fetch existing drum
      try {
        const res = await getEntities(
          "/drums",
          {
            ids: drumId,
            getTotals: true,
          },
          abortController
        );

        const response = res.response;
        if (response.length === 0) {
          setIsLoading(false);
          return;
        }
        setDrum(response[0]);
        setIsLoading(false);
      } catch (error) {
        errorMessageHandler(error);
        setIsLoading(false);
      }
    } else if (isCreateMode && objectId) {
      // Create mode - use utility function for number pre-filling
      await handleDrumNumberPreFill(
        { objectId },
        abortController,
        setDrum,
        setIsLoading,
        null // No need for setLatestNumber in this hook
      );
    } else {
      // Not in create mode or missing required parameters
      if (objectId) {
        setDrum((prevState) => ({
          ...prevState,
          [FieldName.OBJECT_ID]: objectId,
        }));
      }
      setIsLoading(false);
    }
  };
  /**
   * useEffect should have a dependency on drumId
   * so that it fires when this changes (changed url params)
   */
  useEffect(() => {
    const abortController = new AbortController();
    fetchDrumData(abortController);
    return () => {
      abortController.abort();
    };
  }, [drumId]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    drum,
    fetchDrumData,
    isLoading,
  };
};

export default useDrum;
